"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var play_api_1 = require("@l2p/play-api");
var degreeToRadians = function (degree) {
    return (degree * Math.PI) / 180;
};
var WheelSections = function (_a) {
    var _b = _a.wheelSections, wheelSections = _b === void 0 ? [] : _b;
    var _c = (0, react_1.useState)(null), container = _c[0], setContainer = _c[1];
    (0, react_1.useLayoutEffect)(function () {
        var prizesContainerEl = document.querySelector('.wheelFortunePrizes');
        if (prizesContainerEl)
            setContainer(prizesContainerEl);
    }, []);
    var degree = (0, react_1.useMemo)(function () { return 360 / wheelSections.length; }, [wheelSections]);
    var sectionWidth = (0, react_1.useMemo)(function () {
        if (container) {
            var heightParentEl = container.getBoundingClientRect().height;
            var a = heightParentEl / 2;
            return Math.sqrt(Math.pow(a, 2) +
                Math.pow(a, 2) -
                2 * a * a * Math.cos(degreeToRadians(degree)));
        }
        return 0;
    }, [container, degree]);
    return (react_1.default.createElement(react_1.default.Fragment, null, wheelSections.map(function (section, idx, arr) {
        var getClipPath = function () {
            switch (arr.length) {
                default:
                case 2:
                    return 'polygon(0% 0%,100% 0%,100% 50%,0% 50%)';
                case 3:
                    return 'polygon(150% 1%,-50% 1%,50% 50%)';
                case 4:
                    return 'polygon(120% 1%,-20% 1%,50% 50%)';
                case 5:
                    return 'polygon(114% 1%,-12% 1%,50% 50%)';
                case 6:
                    return 'polygon(108% 1%,-8% 1%,50% 50%)';
                case 7:
                    return 'polygon(105% 1%,-5% 1%,50% 50%)';
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                    return 'polygon(103% 1%,-3% 1%,50% 50%)';
            }
        };
        return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.section, " section_").concat(idx), style: {
                width: sectionWidth,
                clipPath: getClipPath(),
                WebkitClipPath: getClipPath(),
                transform: "translate(-50%, 0) rotateZ(".concat(degree * idx, "deg)"),
            }, key: "section_".concat(idx) },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, section.type !== play_api_1.BonusRewardType.FreeRounds
                    ? (0, apps_shared_1.formatNumberShort)(Number(section.value), 0)
                    : section.value),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.descr }, section.description))));
    })));
};
exports.default = WheelSections;
